import axios from 'axios';

const env: string = process.env.NODE_ENV || 'development';
const host = env === 'production' ? 'https://seouldatepop.appspot.com' : 'http://192.168.10.123:8080';

export default axios.create({
  baseURL: `${host}/api/v1`,
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: "json",
});
